// extracted by mini-css-extract-plugin
module.exports = {"bg-gray-very-light":"TourOperatorInvoiceDetail_bg-gray-very-light__3_D-e"};